module.exports = __webpack_public_path__ + "img/napisa-construye.98a3eafe.png";